Apt.fn.extend('profile', {}, {
	/**
	 * Show profile listings
	 */
	initListings() {
		const scope = this;
		const $target = $$('profileListingsApp');
		const app = 'profileListings';

		let events;

		if (! $target.length) {
			return;
		}

		if (location.hash === '#listings') {
			setTimeout(() => {
				LS.util.setScroll('$profileListings');
			});
		}

		if (! scope.map) {
			scope.initMap();
		}

		scope.listings = Apt.fn.index().init({
			app: app,
			view: 'profile._listings',
			resource: 'profiles/' + scope.id + '/listings',
			target: $target,
			scrollTop: '$listingSort',
			paginate: true,
			event: false,
			static: true,
			value: $target.data('value'),
			params: {
				limit: 8,
				location: null
			},
			sorting: Apt.properties.getSorting(),
			transform: Apt.properties.transform,
			unload: () => {
				if (events) {
					events.unload();
				}
			},
			updated: (data, init) => {
				const results = data.results;

				if (! init && events) {
					events.update();
				}

				Object.values(results).forEach(item => {
					LS.analytics.track({
						action: 'preview',
						target: 'listing',
						id: item.id,
						category: 'entry',
						segment: 'profile'
					}, {
						key: item.context.key,
						source: item.context.source,
						send: false
					});
				});

				LS.analytics.send();
			},
			destroy: () => {
				if (events) {
					events.$destroy();
				}

				LS.util.destroy(scope, 'map');
			}
		}, () => {
			events = Apt.fn['properties.events']()
				.init({
					app: app,
					delegate: '$profileListingsApp',
					map: () => scope.map
				});
		});
	}
});